import { useEffect } from 'react';
import Hero from './components/Hero';
import Navigation from '../web-design-development/components/Navigation';
import ServicesGrid from './components/ServicesGrid';
import Contact from './components/Contact';
import Footer from '../home/components/Footer';
import { useSchemaOrg } from '../../utils/seo';

export default function QATestingServices() {
  // Add WebPage Schema
  useSchemaOrg({
    type: 'WebPage',
    data: {
      name: 'QA & Testing Services - Yepes WebLab',
      description: 'Professional quality assurance and testing services. Comprehensive testing solutions to ensure your software works flawlessly.',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/qa-testing-services`,
    },
  });

  // Add Service Schema for QA & Testing
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'Service',
          position: 1,
          name: 'Manual Testing',
          description: 'Comprehensive manual testing to identify bugs and ensure optimal user experience across all platforms.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 2,
          name: 'Automated Testing',
          description: 'Efficient automated testing solutions to accelerate your development cycle and ensure consistent quality.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 3,
          name: 'Mobile Testing',
          description: 'Cross-platform mobile testing to ensure your app works perfectly on all devices and operating systems.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 4,
          name: 'Cross-browser Testing',
          description: 'Comprehensive testing across all major browsers to ensure consistent functionality and user experience.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 5,
          name: 'Ongoing QA',
          description: 'Continuous quality assurance support with regular audits, monitoring, and bug tracking.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 6,
          name: 'Tech Partner',
          description: 'Complete technology partnership with dedicated QA team and strategic planning.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
      ],
    };

    const scriptId = 'schema-qa-services';
    let scriptTag = document.getElementById(scriptId);

    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(serviceSchema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#EBEBE0]">
      <Navigation />
      <Hero />
      <ServicesGrid />
      <Contact />
      <Footer />
    </div>
  );
}